import lj from './lumberjack';
lj.setupLJ();

const query = new URLSearchParams(window.location.search);
const approveToken = query.get('approve_token');
const rejectToken = query.get('reject_token');
const partnerId = query.get('partner_id');
const entityId = query.get('entity_id');
let action;
if (approveToken) {
  action = 'approve';
} else if (rejectToken) {
  action = 'reject';
}

const setLoading = (show = false) => {
  if (show) {
    $('.kyc-access-form-loader').removeClass('hide');
  } else {
    $('.kyc-access-form-loader').addClass('hide');
  }
};

const setError = (show = false, message = 'Something went wrong') => {
  setLoading(false);
  if (show) {
    $('#kyc-access-error').removeClass('hide');
    $('#kyc-access-error #errorMessage').html(message);
  } else {
    $('#kyc-access-error').addClass('hide');
  }
};

const setSubmitted = () => {
  const selector =
    action === 'approve'
      ? 'kyc-access-approved-successfully'
      : 'kyc-access-rejected-successfully';
  $(`#${selector}`).removeClass('hide');
};

const submitForm = () => {
  const payload = {
    partner_id: partnerId,
    entity_id: entityId
  };
  if (approveToken) {
    payload.approve_token = approveToken;
  } else {
    payload.reject_token = rejectToken;
  }
  setLoading(true);
  let apiBaseUrl = 'https://beta-api.stage.razorpay.in';
  if (location.hostname === 'razorpay.com') {
    apiBaseUrl = 'https://api.razorpay.com';
  }
  const uri = `${apiBaseUrl}/v1/partner/kyc_approve_reject`;
  fetch(uri, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(res => {
      if (typeof res === 'object' && !res.ok) {
        throw new Error('Something went wrong');
      } else {
        setSubmitted(true);
        setLoading(false);
      }
    })
    .catch(err => {
      console.log(err);
      const errMsg = err.message || (err && err[0]);
      const errHtml = `Request failed with following error <br/> ${errMsg}`;
      $('#kyc-access-screen #apiErrorMessage').html(errHtml);
      $('#kyc-access-screen').removeClass('hide');
      setLoading(false);
    });
};

window.onload = function() {
  let confirmContent;
  if (partnerId && entityId && action) {
    if (approveToken) {
      confirmContent = 'Are you sure you want to approve the KYC form request?';
    } else if (rejectToken) {
      confirmContent = 'Are you sure you want to reject the KYC form request?';
    }
    $('#kyc-access-screen p.text').html(confirmContent);
    $('#kyc-access-screen').removeClass('hide');
    $('#kyc-access-screen button#confirm').click(function() {
      $('#kyc-access-screen').addClass('hide');
      submitForm();
    });
    $('#kyc-access-screen button#cancel').click(function() {
      $('#kyc-access-screen').addClass('hide');
      setError(true, '<p>Thank you. You can close the window now</p>');
    });
  } else {
    setError(true, 'Requested URL is invalid');
  }
};
